import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Footer from './include/Footer';
import Loader from './include/Loader';
import Menu from './include/Menu'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from "react-toastify";
import axios from 'axios';
import { CONTIGO_API_URL } from '../BaseURL';
const About = () => {

    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem("ContigoU_Admin_ID") == null) {
            navigate("/contigo-u-admin");
            return;
        }
        document.getElementById("page-loader").style.display = "none";
        var element = document.getElementById("page-container");
        element.classList.add("show");
        getCMS();
    }, []);
    const [aboutUs, setAboutUs] = useState('');

    const getCMS = () => {
        const myurl = `${CONTIGO_API_URL}api/admin/get-cms`;

        const bodyFormData = new URLSearchParams();
        bodyFormData.append('auth_code', "Contigo-U$123");

        axios({
            method: "post",
            url: myurl,
            data: bodyFormData,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('ContigoU_Admin_ID') },
        })
            .then(async (response) => {
                console?.log("@@", response?.data.data);
                if (response?.data?.status) {
                    setAboutUs(response?.data?.data?.about_us)
                } else {
                    toast.error("Something went wrong");
                }
            })
            .catch((error) => {
                toast.error("Something went wrong");
            });
    };
    const handleUpdate = () => {
        const myurl = `${CONTIGO_API_URL}api/admin/update-cms`;

        const bodyFormData = new URLSearchParams();
        bodyFormData.append('auth_code', "Contigo-U$123");
        bodyFormData.append('about_us', aboutUs);

        axios({
            method: "post",
            url: myurl,
            data: bodyFormData,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('ContigoU_Admin_ID') },
        })
            .then(async (response) => {
                console?.log("@@", response?.data.data);
                if (response?.data?.status) {
                    toast.success('About Us updated')
                } else {
                    toast.error("Something went wrong");
                }
            })
            .catch((error) => {
                toast.error("Something went wrong");
            });
    }

    return (
        <>
            <Loader />

            <div
                id="page-container"
                className="fade page-sidebar-fixed page-header-fixed"
            >
                <Menu />

                <div id="content" className="content">
                    <ol className="breadcrumb float-xl-right">
                        <li className="breadcrumb-item basePath ">
                            <a href="javascript:;">Home</a>
                        </li>
                        <li className="breadcrumb-item active currentPath">
                            About Us
                        </li>
                    </ol>
                    <h1 className="page-header">About Us</h1>
                    <div className='container'>
                        <CKEditor id="editor" editor={ClassicEditor} onChange={(e, editor) => { setAboutUs(editor.getData()) }} data={aboutUs} />
                        <button type='button' className='btn btn-success' style={{ marginTop: "30px", width: "100px" }} onClick={handleUpdate} >Update</button>
                    </div>
                </div >
                <Footer />
            </div >
        </>
    )
}

export default About